
import SecurityPolicy from "./company/SecurityPolicy";

export { Page }

function Page() {
  return <SecurityPolicy />;
}
